import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgWhatsNew(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 -4 16 24" {...props}>
      <path
        d="M17.822 1.792c.575 1.156.579 2.433-.105 3.216L20 5.006v2.999h-1V16H5V8.004H4V5.007h2.147c-.575-.644-.584-1.595-.006-2.412.843-1.193 2.52-1.592 4.063-.697.592.344 1.099.818 1.535 1.383l.043.057c.093-.236.197-.469.31-.697.396-.794.866-1.455 1.44-1.935 1.62-1.356 3.435-.628 4.29 1.087zM10 8.005H6.75v6.424H10zm7.25 0H14v6.424h3.25V8.004zM7.64 3.488c-.26.368-.202.559.168.627.309.057.66.102 1.045.137.488.044 1.01.07 1.544.08a5.172 5.172 0 00-.105-.141c-.308-.4-.652-.721-1.022-.936-.68-.395-1.289-.25-1.63.233zm7.079-1.603c-.364.305-.709.788-1.011 1.397a8.9 8.9 0 00-.417.991 15.2 15.2 0 001.86-.026c.37-.03.707-.079 1-.144.345-.077.467-.783.05-1.62-.424-.851-.934-1.056-1.482-.598z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('WhatsNew')(SvgWhatsNew);
